<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(itemName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.itemName)">{{ data.item.itemName }}</div>
      </template>

      <template v-slot:cell(quantity)="data">
        {{ Number(data.item.quantity).toFixed(2) }}
      </template>
<!--      <template v-slot:cell(unitPrice)="data">-->
<!--        {{ Number(data.item.unitPrice).toFixed(2) }}-->
<!--      </template>-->
<!--      <template v-slot:cell(amount)="data">-->
<!--        {{ Number(data.item.amount).toFixed(2) }}-->
<!--      </template>-->


      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "AamsGiftRegUsageApprovalDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'itemName', label: '礼物礼品名称', width: '120px'},
        {key: 'brand', label: '品牌', width: '120px'},
        {key: 'model', label: '规格型号', width: '120px'},
        {key: 'unit', label: '单位', width: '120px'},
        {key: 'quantity', label: '数量', width: '120px'},
        // {key: 'unitPrice', label: '单价（元）', width: '120px'},
        // {key: 'amount', label: '金额（元）', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
